import React from 'react';
import './MainLayout.css';
import Sidebar from "../../features/Sidebar/Sidebar/Sidebar";
import useWindowDimensions from '../../hooks/useWindowDimensions';
import SidebarMobileHeader from '../../features/Sidebar/SidebarMobileHeader/SidebarMobileHeader';

function MainLayout({ children }) {
   const { width } = useWindowDimensions();
   const isTablet = width < 1000;

    return (
      <div className="mainLayout__container">
         {isTablet && <SidebarMobileHeader />}
         <aside className="mainLayout__aside">
            <Sidebar />
         </aside>
         <main className="mainLayout__main">
            {children}
         </main>
      </div>
   );
}

export default MainLayout;
